import React, { Component } from "react";
import request from "../../lib/requester";
import _ from "lodash";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import JSBarcode from "jsbarcode";
import canvas from "canvas";

class submitAWB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      awb_no: "",
      success: "",
      dataTable: [],
      baseTable: [],
      loading: false,
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      selectedClaim: [],
    };
  }

  componentDidMount = () => {};

  getList = () => {
    let url = "/api/traces/v1/document/list-claim-by-awb";
    let group = this.state.user.principal_group.map((item, index) => {
      return item.principal_code;
    });
    let param = {
      group: group,
      awb_no: this.state.awb_no,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({ dataTable: data, baseTable: data, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: true });
      }.bind(this),
    });
  };

  exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 160;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(14);

    const newcanvas = canvas.createCanvas(0, 0);
    JSBarcode(newcanvas, this.state.awb_no, { displayValue: true });
    var imgData = newcanvas.toDataURL("image/png");
    const title = "SURAT PENGANTAR DOKUMEN CLAIM";
    const headers = [
      [
        "Claim Number",
        "Customer Name",
        "Principal",
        "Amount",
        "Submitted Date",
      ],
    ];

    const data = this.state.selectedClaim.map((elt) => [
      elt.claim_number,
      elt.customer_name,
      elt.org_initial,
      this.thousandSeparator(elt.total),
      moment(elt.creation_date).format("DD-MMM-YYYY"),
    ]);

    let content = { startY: 150, head: headers, body: data };

    doc.text(title, marginLeft, 40);
    doc.setFontSize(10);
    doc.text(
      "AWB No: " + this.state.awb_no,
      doc.internal.pageSize.width / 2,
      60,
      null,
      null,
      "center"
    );
    doc.addImage(imgData, "PNG", 232, 70, 125, 50);
    doc.autoTable(content);
    doc.save(this.state.awb_no + ".pdf");
  };

  handleChangeAWB = (e) => {
    let value = e.target.value;
    value = value.replace(/\s+/g, "");
    this.setState({ awb_no: value });
  };

  handleSubmitAWB = () => {
    let { selectedClaim, awb_no, dataTable } = this.state;
    if (awb_no.length === 0) {
      alert("AWB Number is empty");
      return false;
    }
    if (selectedClaim.length === 0) {
      alert("Please select claim");
      return false;
    }

    var dif = _.differenceWith(dataTable, selectedClaim, _.isEqual);
    let url = "/api/traces/v1/document/receive-awb";
    let param = {
      claim_confirm: selectedClaim || [],
      claim_reset: dif || [],
      awb_no: awb_no,
      user_name: this.state.user.username,
      source: "arman",
      menu: "awb",
      function: "receive awb",
    };

    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        this.setState({
          loading: false,
          success: "AWB Number has been submitted successfully",
        });
        // this.exportPDF()
        window.setTimeout(() => {
          window.location.reload();
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleRefuseAWB = () => {
    let { selectedClaim, awb_no, dataTable } = this.state;
    if (awb_no.length === 0) {
      alert("AWB Number is empty");
      return false;
    }
    if (selectedClaim.length === 0) {
      alert("Please select claim");
      return false;
    }

    var dif = _.differenceWith(dataTable, selectedClaim, _.isEqual);
    let url = "/api/traces/v1/document/refuse-awb";
    let param = {
      claim_confirm: selectedClaim || [],
      user_name: this.state.user.username,
      source: "arman",
      menu: "awb",
      function: "refuse awb",
      // ,
      // claim_reset: dif || [],
      // awb_no: awb_no
    };

    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        this.setState({
          loading: false,
          success: "AWB Number has been refused",
        });
        // this.exportPDF()
        window.setTimeout(() => {
          window.location.reload();
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleFind = () => {
    if (this.state.awb_no === "") {
      alert("AWB Number is empty");
      return false;
    }
    this.getList();
  };

  handleCheckClaim = (value) => {
    let { selectedClaim, dataTable } = this.state;
    let findIndex = _.findIndex(selectedClaim, function (o) {
      return parseInt(o.claim_id) === parseInt(value);
    });
    if (findIndex < 0) {
      let claimDetail = _.find(dataTable, function (o) {
        return parseInt(o.claim_id) === parseInt(value);
      });
      if (claimDetail) {
        selectedClaim.push(claimDetail);
      }
    } else {
      selectedClaim.splice(findIndex, 1);
    }
    this.setState(selectedClaim);
    let app = this;

    window.setTimeout(() => {
      console.log(app.state.dataTable);
    }, 200);
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  handleCheckAll = (e) => {
    let dataTable = this.state.dataTable;
    let selectedClaimed = [];
    dataTable.forEach((item, index) => {
      selectedClaimed.push(item);
    });
    let isChecked = e.target.checked;
    if (isChecked) {
      this.setState({ selectedClaim: selectedClaimed });
    } else {
      this.setState({ selectedClaim: [] });
    }
  };

  renderTable = () => {
    let app = this;
    const data = {
      columns: [
        {
          Header: () => (
            <span>
              <input
                type="checkbox"
                className="form-control-sm"
                value=""
                onClick={app.handleCheckAll.bind(app)}
              />
            </span>
          ),
          sortable: false,
          resizable: false,
          accessor: "claim_id",
          width: 50,
          className: "text-center",
          Cell: function (row) {
            let findIndex = _.findIndex(app.state.selectedClaim, function (o) {
              return parseInt(o.claim_id) === parseInt(row.value);
            });
            let checked = findIndex >= 0 ? true : false;
            return (
              <input
                type="checkbox"
                name="awb_claim"
                value={row.value}
                onChange={() => {
                  app.handleCheckClaim(row.value);
                }}
                checked={checked}
              />
            );
          },
        },
        {
          Header: "CLAIM NO",
          accessor: "claim_number",
          filterable: true,
        },
        {
          Header: "TRACES NO",
          accessor: "skp_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_initial",
          filterable: true,
        },
        {
          Header: "CUSTOMER",
          accessor: "customer_name",
          filterable: true,
        },
        {
          Header: "AMOUNT",
          accessor: "total",
          className: "text-right",
          Cell: (row) => {
            let value = parseFloat(row.value);
            if (!value) return 0;
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "",
          accessor: "claim_id",
          Cell: (row) => {
            return (
              <span>
                <button
                  className="btn btn-info btn-sm"
                  onClick={() => {
                    this.goDetail(row.value);
                  }}
                >
                  <i class="fas fa-eye"></i> View
                </button>
              </span>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  thousandSeparator = (value) => {
    value = value.toString();
    value = value.replace(/,/g, "").replace(/(?!^-)[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  goDetail = (claim_id) => {
    this.props.history.push("/admin/awb/view/" + claim_id + "?receive");
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {this.showSuccess()}
                    <div className="row">
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="AWB Number"
                          value={this.state.awb_no}
                          onChange={this.handleChangeAWB.bind(this)}
                        />
                      </div>
                      <div className="col-lg-4">
                        <button
                          className="btn btn-info"
                          onClick={this.handleFind.bind(this)}
                        >
                          Find
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-success"
                          onClick={this.handleSubmitAWB.bind(this)}
                        >
                          Confirm
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-danger"
                          onClick={this.handleRefuseAWB.bind(this)}
                        >
                          Refuse
                        </button>
                        &nbsp;
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default submitAWB;
